module.exports = __webpack_public_path__ + "img/bj_zanwu_echarts.8ba7cdd4.png";